import { Close, WarningAmber } from '@mui/icons-material';
import { Box, DialogActions, DialogContentText, IconButton, Tooltip, Typography } from '@mui/material';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Button } from '../../../../components/shared';

const MonthlyValidationDialog = ({ errorModal, onClose }) => (
  <Dialog open={errorModal.open} onClose={onClose} maxWidth={errorModal.showIssueTable ? 'md' : 'sm'} fullWidth>
    <DialogTitle
      variant="subtitle10"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1.5 }}
    >
      {errorModal.title}
      <IconButton onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent
      sx={{
        maxHeight: errorModal.showIssueTable ? '640px' : '400px',
        overflowY: 'auto',
        px: errorModal.showIssueTable ? 0 : 3,
      }}
    >
      {errorModal.message ? (
        <DialogContentText
          variant="body1"
          sx={{
            px: errorModal.showIssueTable ? 3 : 0,
            py: 0,
            mb: errorModal.showIssueTable ? 0 : errorModal.errors.length > 0 ? 1.5 : 0,
            color: 'text.primary',
            lineHeight: 1.6,
          }}
        >
          {errorModal.message}
        </DialogContentText>
      ) : null}
      {errorModal.showIssueTable ? (
        <Box sx={{ mt: 3, borderTop: 1, borderColor: 'divider' }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(0, 1fr) 340px' },
              gap: 2,
              px: 3,
              py: 1.75,
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ color: 'text.secondary', letterSpacing: '0.08em', fontSize: '0.84rem' }}
            >
              LOCATION
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                color: 'text.secondary',
                letterSpacing: '0.08em',
                textAlign: { xs: 'left', sm: 'right' },
                fontSize: '0.84rem',
              }}
            >
              LAST POSTING
            </Typography>
          </Box>
          <Box sx={{ maxHeight: 440, overflowY: 'auto' }}>
            {errorModal.issueRows.map((issue) => (
              <Box
                key={issue.id}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(0, 1fr) 340px' },
                  gap: 2,
                  alignItems: 'center',
                  px: 3,
                  py: 2,
                  borderBottom: 1,
                  borderColor: 'divider',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: 'text.primary',
                    fontFamily: 'monospace',
                    fontSize: '0.98rem',
                    lineHeight: 1.35,
                    letterSpacing: '0.02em',
                  }}
                >
                  {issue.name}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                    gap: 1.25,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                      fontFamily: 'monospace',
                      fontSize: '0.94rem',
                      letterSpacing: '0.02em',
                    }}
                  >
                    {issue.lastPostingLabel}
                  </Typography>
                  <Tooltip title={issue.details || 'Validation issue'} arrow>
                    <WarningAmber sx={{ color: '#F59E0B', fontSize: '1.5rem' }} />
                  </Tooltip>
                </Box>
              </Box>
            ))}
          </Box>
          <Box sx={{ px: 3, pt: 2.5 }}>
            <Typography variant="body1" sx={{ color: '#D98A00', fontWeight: 500, fontSize: '0.98rem' }}>
              {errorModal.issueRows.length} {errorModal.issueRows.length === 1 ? 'issue' : 'issues'} flagged
            </Typography>
          </Box>
        </Box>
      ) : null}
      {errorModal.errors.length > 0 && !errorModal.showIssueTable && (
        <Box sx={{ mt: 1 }}>
          {errorModal.errors.map((error, index) => (
            <DialogContentText key={index} variant="body2" sx={{ mb: 0.5 }}>
              {error}
            </DialogContentText>
          ))}
        </Box>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} variant="contained" color="primary">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default MonthlyValidationDialog;
